"use client";

import Image from "next/image";
import Link from "next/link";
import * as React from "react";

import { Button } from "@/components/ui/button";
import { generateWhatsAppLink } from "@/lib/generateWhatsappLink";
import { trackMetaEvent } from "@/lib/track-meta-event";

import { MotionFadeIn } from "../motion-fade-in";

export default function HeroCarousel() {
  return (
    <section className="relative overflow-hidden shadow md:mx-4 md:rounded-lg">
      <div className="absolute inset-0 z-0 bg-[url('/icons/icon-192x192.png')] bg-position-[120px_120px] bg-repeat opacity-15 grayscale" />

      <div className="absolute right-0 bottom-0 hidden lg:block xl:right-0 2xl:right-0">
        <MotionFadeIn direction="right">
          <Image
            src="/hero-image.png"
            alt="Gato e Cachorro"
            className="max-w-[70vh] object-contain md:max-w-[70vh] 2xl:max-w-[90vh]"
            height={800}
            width={800}
            priority
          />
        </MotionFadeIn>
      </div>

      <div className="relative z-20 mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8 lg:py-20 xl:py-32">
        <div className="items-center gap-12">
          <div className="space-y-8">
            <MotionFadeIn direction="left">
              <h1 className="color-default leading- mx-auto max-w-3xl text-center text-4xl font-bold text-balance sm:text-5xl md:text-6xl md:leading-18 lg:mx-0 lg:text-left xl:text-6xl 2xl:text-7xl">
                Atendimento Veterinário de Urgência e Emergência 24h
              </h1>
            </MotionFadeIn>

            <MotionFadeIn direction="left" delay={0.1}>
              <p className="mx-auto max-w-lg text-center leading-relaxed text-balance text-[#6e7172] sm:text-lg lg:mx-0 lg:max-w-lg lg:text-left">
                Equipe pronta para agir imediatamente em situações críticas.
                Cuidado rápido, seguro e especializado para o seu pet, a
                qualquer hora do dia.
              </p>
            </MotionFadeIn>

            <MotionFadeIn direction="bottom" delay={0.2}>
              <div className="flex flex-col justify-center gap-4 sm:flex-row lg:justify-start">
                <Button size="xl" onClick={() => trackMetaEvent("Lead")}>
                  <Link
                    href={generateWhatsAppLink(
                      process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || "",
                      "Olá! Gostaria de mais informações.",
                    )}
                    target="_blank"
                  >
                    Agendar Consulta
                  </Link>
                </Button>

                <Button size="xl" variant="secondary" asChild>
                  <Link href={`tel:${process.env.NEXT_PUBLIC_WHATSAPP_NUMBER}`}>
                    Emergência 24h
                  </Link>
                </Button>
              </div>
            </MotionFadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}
